/* eslint-disable no-restricted-imports */

import { initGraphQLTada } from 'gql.tada'
import { introspection } from 'graphql-env'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    Date: string
    DateTime: string
    TimeDelta: string
    Time: string
  }
}>()
